jQuery(function ($) {
    $( document ).ready(function() {
        // console.log('Funnel script v2 loaded...');
        
        var section1          = $("#funnel-product-categories-grid");
        var section2          = $("#funnel-single-product-category");
        var section3          = $("#funnel-single-product");
        var dummyTr           = $("#funnel-dummy-tr-to-show");
        var addedProductBlock = $("#funnel-added-product-to-show");
        
        
        var breadcrumbsStep1 = $(".funnel #breadcrumbs .breadcrumb.container").children("li").eq(1);
        var breadcrumbsStep1slash = $(".funnel #breadcrumbs .breadcrumb.container").children("li").eq(1).next('div');
        var breadcrumbsStep2 = $(".funnel #breadcrumbs .breadcrumb.container").children("li").eq(2);
        var breadcrumbsStep2slash = $(".funnel #breadcrumbs .breadcrumb.container").children("li").eq(2).next('div');
        var breadcrumbsStep3 = $(".funnel #breadcrumbs .breadcrumb.container").children("li").eq(3);

        // Step-0: hide all breadcrumbs except first two Hem / Planera begravning
        // $(".funnel #breadcrumbs li:not(:nth-child(1):not(:nth-child(2))").css('display','none');
        breadcrumbsStep1.addClass('active').attr('aria-current', 'page');
        breadcrumbsStep1slash.css('display','none');
        breadcrumbsStep2.css('display','none');
        breadcrumbsStep2slash.css('display','none');
        breadcrumbsStep3.css('display','none');
        
        
        // Step-1: click on any product category - a.funnel-single-prod-category-link
        $( document ).on( "click", ".funnel-single-prod-category-link", function() {
            // console.log('Step-1 prodCat entered');
            thisElementCollapse( section1 );
            thisElementExpand( section2 );
            breadcrumbsStep1.removeClass('active').attr('aria-current', '');
            breadcrumbsStep1slash.show();
            breadcrumbsStep2.show().addClass('active').attr('aria-current', 'page');
            // $('#funnel-left-heading').addClass('hidden-on-mob');
            // $('#funnel-left-heading').slideUp();
            scrollToTop( $("body") );
        });

        function showStep2() {
            thisElementCollapse( "#funnel-product-categories-grid" );
            thisElementExpand( "#funnel-single-product-category" );
        }
        
        // Step-2: click on any product - a.product-row-link
        $( document ).on( "click", ".product-row-link", function() {
            // console.log('Step-2 Product entered');
            thisElementCollapse( section2 );
            thisElementExpand( section3 );
            breadcrumbsStep2.show().removeClass('active').attr('aria-current', '');
            breadcrumbsStep2slash.show();
            breadcrumbsStep3.show();
            scrollToTop( $("body") );
        });
        
        function showStep3() {
            thisElementCollapse( section2 );
            thisElementExpand( section3 );
        }
        
        
        // click on Valj button for Quick add to Cart
        $( document ).on( "click", ".funnel-quick-add, #btnAddToCartFunnel", function( e ) {
            // console.log('.funnel-quick-add / #btnAddToCartFunnel clicked');
            /* if (  $( this ).hasClass('selected') ) {
                $( this ).removeClass('selected').html('+&nbsp;Välj').prev('.product-row-link').children('.prod-wrapper').children('.prod-image-wrapper').removeClass('selected');
            } else {  */

                // $( this ).addClass('selected').text('Ta bort').prev('.product-row-link').children('.prod-wrapper').children('.prod-image-wrapper').addClass('selected');
                
                $( this ).addClass('selected').html('&#10003; Tillagd').prev('.product-row-link');
                $('#navCartIcon').addClass('mob filled');
                $( '#mobGrundpris' ).text('Summa:');
            /* } */

            // myFunnelSummaryCollapse();  // this now fires from AJAX-product-list / -single
            scrollToTop( $("body") );
            myBlinkJustAddedProduct ();
        });
        
        // click on "X" to close current Step section and show previous Step
        $( document ).on( "click", ".funnel-close.step2", function() {
            // console.log('Step2 X clicked');
            $( this ).closest('.container').slideUp('slow');
            $('#funnel-product-categories-grid').slideDown('slow');
            breadcrumbsStep1.addClass('active').attr('aria-current', 'page');
            breadcrumbsStep1slash.hide();
            breadcrumbsStep2.hide();
        });
        
        $( document ).on( "click", ".funnel-close.step3", function() {
            // console.log('Step3 X clicked');
            $( this ).closest('.container').slideUp('slow');
            $('#funnel-single-product-category').slideDown('slow');
            breadcrumbsStep2.attr('aria-current', 'page');
            breadcrumbsStep2slash.hide();
            breadcrumbsStep3.hide();
        });
        
        // hover on "X" adds a box-shadow to the section - Den: DEPRECATED
        /* $( document ).on( "hover", ".funnel-close", function() {
            // console.log('X hover on');
            $( this ).closest('.container').toggleClass('close-hover');
        }); */
        
        // click on products added to Cart .funnel-added-prod-title
        $( document ).on( "click", ".funnel-added-prod-title", function() {
            // console.log('.funnel-added-prod-title clicked');
            scrollToTop( $("body") );
            // $(".funnel-close.step3").click();
            // $(".funnel-single-prod-category-link[href='kista']").click();
        });
        
        // THREE BUTTONS - DEPRECATED
        // clicks on mobile tabs to show/hide sections - fun-mob-btn-1-options etc.
/*        var funOptions = $('#primary');
        var funnelSide = $('#funnel-side');
        var funSummary = $('#WrapFunnelCart');
        var funDetails = $('#WrapFunnelDetails');
        
        $( document ).on( "click", "#fun-mob-btn-1-options", function() {
            console.log('fun-mob-btn-1-options clicked');
            thisElementCollapse( funSummary );
            thisElementCollapse( funDetails );
            funnelSide.hide();
            thisElementExpand( funOptions );
        });
        
        $( document ).on( "click", "#fun-mob-btn-2-summary", function() {
            console.log('fun-mob-btn-2-summary clicked');
            thisElementCollapse( funOptions );
            thisElementCollapse( funDetails );
            funnelSide.show();
            thisElementExpand( funSummary );
        });
        
        $( document ).on( "click", "#fun-mob-btn-3-details", function() {
            console.log('fun-mob-btn-3-details clicked');
            thisElementCollapse( funOptions );
            thisElementCollapse( funSummary );
            funnelSide.show();
            thisElementExpand( funDetails );
        });
        
        $( document ).on( "click", ".three-buttons.funnel label", function() {
            $(".three-buttons.funnel label").removeClass('btn-outline-primary').addClass('btn-light');
            $(this).toggleClass("btn-outline-primary btn-light");
        });
*/        
        
        // TWO BUTTONS
        // clicks on mobile tabs to show/hide sections - fun-mob-btn-1-options etc.
        var funOptions = $('#primary');
        var funnelSide = $('#funnel-side');
        
        $( document ).on( "click", "#fun-mob-btn-1-options", function() {
            // console.log('fun-mob-btn-1-options clicked');
            thisElementCollapse( funnelSide );
            thisElementExpand( funOptions );
        });
        
        $( document ).on( "click", "#fun-mob-btn-2-summary", function() {
            // console.log('fun-mob-btn-2-summary clicked');
            thisElementCollapse( funOptions );
            thisElementExpand( funnelSide );
             $('#navCartIcon').removeClass('filled');
            
        });
        
        $( document ).on( "click", ".two-buttons.funnel label", function() {
            $(".two-buttons.funnel label").removeClass('btn-outline-primary').addClass('btn-light');
            $(this).toggleClass("btn-outline-primary btn-light");
        });
        
        /* MOBILE Funnel */
        if ($(window).width() < 768 ) {
            /* Click on a cart - simulate click on 'Sammanställning' button */
            $( document ).on( "click", "#topbar-mob-totalsumma", function() {
                $("#fun-mob-btn-2-summary").click();
                $(".two-buttons.funnel label").click();
            });
            
            /* Click on any added product in the Summary - simulate click on 'Tillval' button */
            $( document ).on( "click", ".funnel-added-product.shown", function() {
                // console.log('.funnel-added-product.shown - click');
                $("#fun-mob-btn-1-options ~ label").removeClass('btn-light').addClass('btn-outline-primary');
                $("#fun-mob-btn-2-summary ~ label").removeClass('btn-outline-primary').addClass('btn-light');
                $("#fun-mob-btn-1-options").click();
            });
            
            /* If came with URL param ?restore=yes - open Summary on load */
            if (jQuery.urlParam('restore') == 'yes') {
                $("#fun-mob-btn-2-summary").click();
                $(".two-buttons.funnel label").click();
            }
            $("#fun-mob-btn-2-summary").click();
            $(".two-buttons.funnel label").click();
        }
    }); // $( document ).ready(function() {...}
    
    
    
    // Helper function to blink a product block recently added to Cart    
    function myBlinkJustAddedProduct() {
        setTimeout(function(){
          jQuery( '.funnel-summary > tbody > .funnel-added-product' ).eq(-1).addClass('just-added');
          setTimeout(function(){
              jQuery('.funnel-summary > tbody > .funnel-added-product.just-added').removeClass('just-added');
          }, 600);
        }, 75);
        // console.log('I blinked');
    }
    
    // Helper function to scroll to the top
    function scrollToTop( el, offset ){   /* default offset of 180px for desktops - deprecated  */
        if (offset === undefined) {
            offset = 0;
        }
        /* if ($(window).width() > 575 ) {  
            offset = 180;
        } */
        // console.log('offset ', offset);

        var objToScroll = el;
        setTimeout(function(){
            $("html, body").delay(10).animate({scrollTop: objToScroll.offset().top + offset }, 400);
        }, 300);
        // console.log('I scrolled!')
    }
    
    // Helper function to collapse always included products block
    /* function myFunnelSummaryCollapse() {
      $( '#funnelCartSummaryAlwaysIncludedWrap' ).slideUp('slow'); // hide
      $( '.fun-drop-down i.fenix-icon.icon-right').removeClass('open');
         //console.log('slideUp > hide');
      
      $( '#funnelCartSummaryAlwaysIncludedCollapsedWrap' ).slideDown('slow'); // show
        // console.log('slideDown > show');
    } */
    
    // Den: Helper function to collapse always included products block - this RUNS from products/ajax-cart-funnel
    function myFunnelSummaryCollapse() {
        jQuery( '#funnelCartSummaryAlwaysIncludedCollapsedWrap' ).slideDown('slow'); // show
          // console.log('Always included sub-totals: slideDown > show!');
    
          if ( jQuery( '#funnelCartSummaryAlwaysIncludedWrap' ).is(":visible") ) {
              jQuery( '#funnelCartSummaryAlwaysIncludedWrap' ).slideUp('fast'); // hide
              jQuery( '.fun-drop-down i.fenix-icon.icon-right').removeClass('open');
              // console.log('Always included rows: slideUp > hide!');
          } else {
              jQuery( '#funnelCartSummaryAlwaysIncludedWrap' ).slideDown('fast'); // show
              jQuery( '.fun-drop-down i.fenix-icon.icon-right').addClass('open');
              // console.log('Always included rows: slideDown > show!');
          }
    }
    
}); // jQuery(function ($) {...}

// Helper functions to Show/Hide blocks
function thisElementCollapse( element ) {
  // console.log('thisElementCollapse');
    jQuery( element ).slideUp('slow');
}

function thisElementExpand( element ) {
  // console.log('thisElementExpand');
    jQuery( element ).slideDown('slow');
}

function showAddedProductBlock() {
    const dummyTr           = document.getElementById("funnel-dummy-tr-to-show");
    const addedProductBlock = document.getElementById("funnel-added-product-to-show");

    addedProductBlock.style.display = "table-row";
    dummyTr.style.display = "table-row";
}

function myFunnelSummaryExpand() {
  // $( 'table#funnelCartSummary tr:not(#funnel-dummy-tr-to-show, #funnel-added-product-to-show)' ).slideUp('slow');
  // console.log('slideDown');
  jQuery( '#funnelCartSummaryAlwaysIncludedWrap' ).slideDown('slow'); // show
//   jQuery( '#funnelCartSummaryAlwaysIncludedCollapsedWrap' ).slideUp('slow'); // hide
    jQuery( '.fun-drop-down i.fenix-icon.icon-right').addClass('open');
}

function myFunnelQuickAddToSummary() {
  // $( 'table#funnelCartSummary tr:not(#funnel-dummy-tr-to-show, #funnel-added-product-to-show)' ).slideUp('slow');
  // console.log('quick add');
  myFunnelSummaryCollapse();
  // showAddedProductBlock();
}

